import { WALLET_LABELS } from "@nexus-cross/crossx-design-system";
import {
  AppleIcon,
  BinanceIcon,
  CROSSxIcon,
  GoogleIcon,
  MetaMaskIcon,
  TronIcon,
  Verse8Icon,
} from "./components/icons";
import type { SocialConfig, WalletConfig } from "./types";

export const WALLET_REGISTRY = {
  cross_embedded: {
    id: "cross_embedded",
    name: WALLET_LABELS.social,
    description: "Sign in with Google or Apple",
    icon: CROSSxIcon,
  },
  cross_wallet: {
    id: "cross_wallet",
    name: WALLET_LABELS.app,
    description: "App approval is required",
    icon: CROSSxIcon,
    featured: true,
  },
  cross_extension: {
    id: "cross_extension",
    name: WALLET_LABELS.extension,
    description: "Browser extension approval is required",
    icon: CROSSxIcon,
    rdns: "nexus.to.crosswallet.desktop",
    installUrl:
      "https://chromewebstore.google.com/detail/crossx/nninbdadmocnokibpaaohnoepbnpdgcg",
    visibility: "desktop-only" as const,
  },
  metamask: {
    id: "metamask",
    name: "MetaMask",
    description: "Browser extension approval is required",
    icon: MetaMaskIcon,
    rdns: "io.metamask",
  },
  binance: {
    id: "binance",
    name: "Binance",
    description: "Mobile app only — Add CROSS network first",
    icon: BinanceIcon,
  },
  verse8: {
    id: "verse8",
    name: "Verse8 Wallet",
    description: "Optimized for Forge and Verse8 ecosystem",
    icon: Verse8Icon,
    badge: "For Forge",
  },
  tron: {
    id: "tron",
    name: "Tron Wallet",
    description: "Dedicated for Tron-based transactions and assets",
    icon: TronIcon,
    badge: "For SHOP",
  },
} satisfies Record<string, WalletConfig>;

export type WalletId = keyof typeof WALLET_REGISTRY;

export function resolveWallet(id: WalletId): WalletConfig {
  return WALLET_REGISTRY[id];
}

export const SOCIAL_REGISTRY = {
  google: {
    id: "google",
    name: "Google",
    icon: GoogleIcon,
  },
  apple: {
    id: "apple",
    name: "Apple",
    icon: AppleIcon,
  },
} satisfies Record<string, SocialConfig>;

export type SocialId = keyof typeof SOCIAL_REGISTRY;

export function resolveSocial(id: SocialId): SocialConfig {
  return SOCIAL_REGISTRY[id];
}
